import React from "react";

type DocumentDownloadIconProps = {
  className?: string;
  fill?: string;
  onClick?: () => void;
  dataTestId?: string;
};
export default function DocumentDownloadIcon({
  className,
  fill,
  onClick,
  dataTestId,
  ...props
}: DocumentDownloadIconProps) {
  return (
    <div onClick={onClick ? onClick : undefined}>
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill={fill ? fill : "none"}
        className={className}
        data-testid={dataTestId}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.5 11.5L8 13.5M8 13.5L10.5 11.5M8 13.5V8M13 19H3C1.89543 19 1 18.1046 1 17V3C1 1.89543 1.89543 1 3 1H10.1716C10.702 1 11.2107 1.21071 11.5858 1.58579L14.4142 4.41421C14.7893 4.78929 15 5.29799 15 5.82843V17C15 18.1046 14.1046 19 13 19Z"
          stroke="#0000F5"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
